exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title{font-weight:700}.header-component{position:relative}.header-component-components{position:absolute;top:15px;right:15px}.header-component-components>div{float:right;margin-left:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3978ce9e!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HeaderComponent.vue
// module id = 872
// module chunks = 2